import { createAction, props } from '@ngrx/store';

import { InboxDelivery } from 'app/core/models/inbox-delivery.model';

const ACTION_KEY = '[Inbox]';

export const showLoading = createAction(`${ACTION_KEY} show loading `);

export const loadDeliveries = createAction(`${ACTION_KEY} Load state `);

export const loadInboxSuccess = createAction(
  `${ACTION_KEY} Load state  success`,
  props<{ payload: InboxDelivery[] }>(),
);

export const loadMoreInboxSuccess = createAction(
  `${ACTION_KEY} Load more success`,
  props<{ payload: InboxDelivery[] }>(),
);

export const loadInboxFail = createAction(`${ACTION_KEY} Load state fail`);

export const resetInbox = createAction(`${ACTION_KEY} Reset inbox`);

export const setVisitedFlag = createAction(
  `${ACTION_KEY} Set visited flag`,
  props<{ payload: string }>(),
);

export const loadUnreadNumberSuccess = createAction(
  `${ACTION_KEY} Load unread number success`,
  props<{ unreadNumber: number }>(),
);

export const loadUnreadNumberFail = createAction(`${ACTION_KEY} Load unread number fail`);

export const setPage = createAction(`${ACTION_KEY} Set page`, props<{ page: any }>());

export const incrementPage = createAction(`${ACTION_KEY} Increment page`);

export const searchIncome = createAction(
  `${ACTION_KEY} Search`,
  props<{ searchText: string; page: string; status: string }>(),
);

export const searchIncomeSuccess = createAction(
  `${ACTION_KEY} Search  success`,
  props<{ deliveries: InboxDelivery[] }>(),
);

export const searchIncomeFail = createAction(`${ACTION_KEY} search  failed`);

export const refresh = createAction(`${ACTION_KEY} refresh list`);

export const reactivateDelivery = createAction(
  `${ACTION_KEY} Reactivate Delivery`,
  props<{ deliveryId: string }>(),
);

export const reactivateDeliverySuccess = createAction(
  `${ACTION_KEY} Reactivate Delivery Success`,
  props<{ payload: any }>(),
);

export const reactivateDeliveryFail = createAction(
  `${ACTION_KEY} Reactivate Delivery Fail`,
  props<{ payload: any }>(),
);

export const setScrollPosition = createAction(
  `${ACTION_KEY} set scroll position`,
  props<{ scrollPosition: number }>(),
);
